import { render, staticRenderFns } from "./PromptNode.vue?vue&type=template&id=12a80253&scoped=true&"
import script from "./PromptNode.vue?vue&type=script&lang=js&"
export * from "./PromptNode.vue?vue&type=script&lang=js&"
import style0 from "./PromptNode.vue?vue&type=style&index=0&id=12a80253&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a80253",
  null
  
)

export default component.exports